'use strict';

module.exports = {
  CANVAS_EXTRACT: 'canvas_extract',
  PRODUCT_LEVEL_EXTRACT: 'product_level_extract',
  STORE_LEVEL_EXTRACT: 'store_level_extract',
  PRODUCT_OUTBOUND_API_EXTRACT: 'product_outbound_api_extract',
};
